<template>
  <div class="page-wrap">
    <el-dialog :close-on-click-modal="false" title="应用管理" :visible.sync="dialogVisible" width="1014px">
      <div class="modal-body">
        <div class="filter"></div>
        <div class="table-wrap">
          <el-table :data="proTableList" style="width: 100%" max-height="500px">
            <el-table-column prop="app_cloud_id" label="应用ID" width="120"> </el-table-column>
            <el-table-column prop="app_name" label="应用名称">
              <template slot-scope="scope">
                <div style="display: flex">
                  <img :src="scope.row.icon_url" style="width: 36px; height: 36px" />
                  <span style="margin-left: 8px; line-height: 40px">{{ scope.row.app_name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="package_name" label="应用包名" width="250"></el-table-column>
            <el-table-column prop="operate" label="操作" width="130">
              <template slot-scope="scope">
                <el-button type="text" @click="handlerChoose(scope.row)">使用该应用包</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="footer-wrap"> </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGoogleAppList } from "@/api/promotion-google.js";
export default {
  data() {
    return {
      dialogVisible: false,
      proTableList: [],
      adCount: "",
      loading: false,
    };
  },

  computed: {},

  watch: {},

  mounted() {},

  methods: {
    async showModal(adCount) {
      this.adCount = adCount;
      await this.getList();
      this.dialogVisible = true;
    },
    getList() {
      getGoogleAppList({
        advertiserId: this.adCount,
      }).then((res) => {
        this.proTableList = res.data;
      });
    },
    handlerChoose(row) {
      this.$emit("chooseCallback", row);
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.modal-body {
  padding-bottom: 30px;
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #000;
    cursor: pointer;
    margin-bottom: 8px;
    width: 350px;
  }
  .product-icon {
    width: 50px;
  }
}
</style>
